import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { addParamsToUrl } from 'utils';
import { CourseSubmission, PaginationResponse } from 'types';

import { apiQuery } from '../../query';
import {
  courseEnrollmentsApi,
  courseEnrollmentsTagType,
} from '../course-enrollments';
import {
  courseStepSubmissionsApi,
  courseStepSubmissionsTagType,
} from '../course-step-submissions';

import {
  ListRequest,
  CourseSubmissionResponse,
  LastCourseSubmissionResponse,
} from './types';

const tagType = 'COURSE_SUBMISSIONS';

const tagTypes = [tagType];

export const courseSubmissionsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'courseSubmissionsApi',
  endpoints: (build) => ({
    last: build.query<CourseSubmission | undefined, void>({
      providesTags: tagTypes,
      transformResponse: (response: LastCourseSubmissionResponse) =>
        response.data,
      query: () => ({
        method: 'get',
        url: URL.COURSE_SUBMISSIONS_LAST,
      }),
    }),

    list: build.query<
      PaginationResponse<CourseSubmission> | undefined,
      ListRequest
    >({
      providesTags: tagTypes,
      transformResponse: (response: CourseSubmissionResponse) => response.data,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.COURSE_SUBMISSIONS, params),
      }),
    }),

    reset: build.mutation<void, void>({
      invalidatesTags: tagTypes,
      query: () => ({
        method: 'post',
        url: URL.COURSE_SUBMISSIONS_RESET,
      }),

      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            courseEnrollmentsApi.util.invalidateTags([courseEnrollmentsTagType])
          );
          dispatch(
            courseStepSubmissionsApi.util.invalidateTags([
              courseStepSubmissionsTagType,
            ])
          );
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const { useLastQuery, useListQuery, useResetMutation } =
  courseSubmissionsApi;

export { tagType as courseSubmissionsTagType };
